export const flattenInfiniteData = <TResponse, TItem>(
    responses: TResponse[] = [],
    extractFn: (response: TResponse) => TItem[],
): TItem[] => {
    return responses.reduce((flat, toFlatten) => {
        return flat.concat(extractFn(toFlatten));
    }, []);
};

export const fetchMoreDelayed = (
    canFetchMore: boolean,
    isFetchingMore: boolean | string,
    isFetching: boolean,
    fetchMore: () => void,
) => {
    if (canFetchMore && !isFetchingMore && !isFetching) {
        process.nextTick(() => fetchMore());
    }
};
